import styled from 'styled-components';
import { getCDNImageUrl } from '@/helpers/cdn';
import type { FieldStructureProps } from './FieldStructure';

const successIcon = getCDNImageUrl('/icon-img/tickCircleIcon.svg');
const errorIcon = getCDNImageUrl('/icon-img/tickCircleDeclineIcon.svg');

export const ScInputStructure = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;

  .content {
    position: relative;

    & > .input-icon {
      position: absolute;
      top: 8px;
      left: 7px;
      border-radius: 50%;
    }

    .addons {
      position: absolute;
      height: 100%;
      top: 0;
      right: 4px;
      display: flex;
      align-items: center;
      gap: 4px;

      & > .icon {
        width: 32px;
        height: 32px;
        object-fit: contain;
        &.error-icon {
          background: ${() => `url(${errorIcon}) center no-repeat`};
        }
        &.success-icon {
          background: ${() => `url(${successIcon}) center no-repeat`};
        }
      }
    }
  }

  & > .info,
  & .error,
  & .content > .error {
    font-size: 12px;
    line-height: 18px;
    padding: 0 16px;
    position: relative;
  }

  & > .info {
    color: ${({ theme }) => theme.color3};
  }

  & .content > .error,
  & .error {
    color: ${({ theme }) => theme.redColor};
  }

  & .prefix {
    position: absolute;
    left: 16px;
    font-size: 16px;
    font-weight: 700;
    line-height: 40px;
    letter-spacing: 0.01em;
    color: ${({ theme }) => theme.white};
  }
`;

export const ScFieldStructure = styled.div<FieldStructureProps>`
  position: relative;

  .field-container {
    position: relative;
    opacity: ${({ disabled }) => (disabled ? '0.4' : '1')};
  }

  .addons {
    padding-bottom: 8px;
  }
`;

export const ScError = styled.div`
  color: ${({ theme }) => theme.error};
  font-size: 12px;
  line-height: 18px;
  padding: 0 16px;
  margin-top: 2px;
  position: relative;

  &::first-letter {
    text-transform: capitalize;
  }
`;
